import ID from './ID'

export default class FlowSubRow {
  constructor(
    public index: number = 0,
    public planningItems: {id: ID; startDate: Date; endDate: Date}[] = []
  ) {}
}
